import { LineItem } from "@wingspanhq/wingspan-api-sdk";

export const selectorIsLineItemPricedPerUnit = (lineItem: LineItem): boolean =>
  !!lineItem.unit &&
  lineItem.quantity != null &&
  lineItem.unitCost != null &&
  // The API normalizes fixed prices to quantity 1 with the default unit "unit".
  !(lineItem.unit === "unit" && lineItem.quantity === 1);
